export const SECTION_GROUPS = [
  { label: "Genel", items: ["dashboard", "assistant", "messages", "appointments", "assistantLogs", "site", "pages"] },
  { label: "Ana Sayfa", items: ["hero", "intro", "stats", "manifesto", "marquee", "roomsPreview", "servicesPreview", "homeVideo"] },
  { label: "İçerik", items: ["rooms", "services", "values", "about", "included", "servicesBanner"] },
  { label: "Medya", items: ["gallery", "videos"] },
  { label: "Diğer", items: ["cta", "footer"] },
];

const pageFields = (withHero = true) => {
  const seo = [
    { key: "seoTitle", label: "SEO Başlığı (Title)" },
    { key: "seoDesc", label: "SEO Açıklaması (Description)", type: "area" },
  ];
  if (!withHero) return seo;
  return [
    { key: "overline", label: "Üst Etiket (Overline)" },
    { key: "titleLines", label: "Başlık Satırları (her satır yeni satır; *italik* için yıldız kullanın)", type: "lines" },
    { key: "description", label: "Açıklama", type: "area" },
    ...seo,
  ];
};

export const SECTION_META = {
  dashboard: { label: "Genel Bakış", icon: "LayoutDashboard", desc: "Site özeti ve son mesajlar" },
  assistant: { label: "Yapay Zeka Asistanı", icon: "Sparkles", desc: "Paneli sizin için kullanır — foto ekler, metin düzeltir, özet çıkarır" },
  messages: { label: "Mesajlar", icon: "Inbox", desc: "İletişim formundan gelen mesajlar" },
  appointments: { label: "Randevular", icon: "CalendarCheck", desc: "Ada Asistan üzerinden oluşturulan randevu talepleri" },
  assistantLogs: { label: "Asistan Kayıtları", icon: "MessagesSquare", desc: "Ziyaretçilerin Ada Asistan ile konuşmaları" },
  site: {
    label: "Site Bilgileri",
    icon: "Settings",
    desc: "İletişim, adres, WhatsApp ve sosyal medya",
    fields: [
      { key: "name", label: "Marka Adı" },
      { key: "fullName", label: "Tam İşletme Adı" },
      { key: "phone", label: "Telefon (görünen)" },
      { key: "phoneTel", label: "Telefon (tel: formatı, örn. +905057990055)" },
      { key: "phone2", label: "Sabit Hat (görünen)" },
      { key: "phone2Tel", label: "Sabit Hat (tel: formatı)" },
      { key: "whatsapp", label: "WhatsApp Numarası (905...)" },
      { key: "whatsappMessage", label: "WhatsApp Hazır Mesajı", type: "area" },
      { key: "email", label: "E-posta" },
      { key: "address", label: "Adres", type: "area" },
      { key: "instagram", label: "Instagram URL" },
      { key: "mapQuery", label: "Harita Konumu (Google Maps sorgusu)" },
    ],
  },
  pages: {
    label: "Sayfalar & SEO",
    icon: "FileText",
    desc: "Her sayfanın başlığı, açıklaması ve SEO meta etiketleri",
    fields: [
      { key: "home", label: "Ana Sayfa", type: "group", fields: pageFields(false) },
      { key: "hakkimizda", label: "Hakkımızda", type: "group", fields: pageFields() },
      { key: "odalar", label: "Odalar", type: "group", fields: pageFields() },
      { key: "hizmetler", label: "Hizmetler", type: "group", fields: pageFields() },
      { key: "galeri", label: "Galeri", type: "group", fields: pageFields() },
      { key: "videolar", label: "Videolar", type: "group", fields: pageFields() },
      { key: "iletisim", label: "İletişim", type: "group", fields: pageFields() },
    ],
  },
  hero: {
    label: "Hero / Slider",
    icon: "GalleryHorizontal",
    desc: "Ana sayfa karşılama alanı ve arka plan slider görselleri",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "titleLines", label: "Başlık Satırları (*italik* destekler)", type: "lines" },
      { key: "subtitle", label: "Alt Açıklama", type: "area" },
      { key: "primaryCta", label: "Birinci Buton Metni" },
      { key: "secondaryCta", label: "İkinci Buton Metni" },
      {
        key: "slides", label: "Slider Görselleri", type: "array", itemTitle: "alt",
        template: { src: "", alt: "Yeni görsel" },
        itemFields: [
          { key: "src", label: "Görsel", type: "image" },
          { key: "alt", label: "Görsel Açıklaması (alt)" },
        ],
      },
    ],
  },
  intro: {
    label: "Tanıtım Bölümü",
    icon: "Home",
    desc: "Ana sayfadaki 'Ada'ya Hoş Geldiniz' alanı",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık (*italik* destekler)" },
      { key: "description", label: "Açıklama", type: "area" },
      { key: "linkText", label: "Bağlantı Metni" },
      { key: "image", label: "Görsel", type: "image" },
      { key: "badgeValue", label: "Kart Büyük Metin" },
      { key: "badgeLabel", label: "Kart Küçük Metin" },
    ],
  },
  stats: {
    label: "İstatistikler",
    icon: "BarChart3",
    desc: "Ana sayfa ve hakkımızda sayfasındaki sayısal veriler",
    fields: [
      {
        key: "", label: "İstatistikler", type: "array", itemTitle: "label", root: true,
        template: { value: "0", label: "Yeni İstatistik" },
        itemFields: [
          { key: "value", label: "Değer (örn. 2 dk)" },
          { key: "label", label: "Etiket" },
        ],
      },
    ],
  },
  manifesto: {
    label: "Manifesto",
    icon: "ScrollText",
    desc: "Numaralı ilke bölümleri",
    fields: [
      {
        key: "", label: "İlkeler", type: "array", itemTitle: "title", root: true,
        template: { no: "04", title: "Yeni İlke", text: "" },
        itemFields: [
          { key: "no", label: "Numara (örn. 01)" },
          { key: "title", label: "Başlık" },
          { key: "text", label: "Metin", type: "area" },
        ],
      },
    ],
  },
  marquee: {
    label: "Kayan Yazı",
    icon: "MoveHorizontal",
    desc: "Ana sayfadaki akan şerit metinleri",
    fields: [{ key: "", label: "Öğeler (her satır bir öğe)", type: "lines", root: true }],
  },
  roomsPreview: {
    label: "Oda Bölümü Başlığı",
    icon: "BedDouble",
    desc: "Ana sayfadaki odalar bölümü metinleri",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık" },
      { key: "description", label: "Açıklama", type: "area" },
      { key: "allLabel", label: "'Tüm Odalar' Buton Metni" },
    ],
  },
  servicesPreview: {
    label: "Hizmet Bölümü Başlığı",
    icon: "Sparkles",
    desc: "Ana sayfadaki hizmetler bölümü metinleri",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık" },
      { key: "description", label: "Açıklama", type: "area" },
    ],
  },
  homeVideo: {
    label: "Video Bölümü Başlığı",
    icon: "Play",
    desc: "Ana sayfadaki video alanı metinleri (video listesi 'Videolar' bölümünden)",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık" },
    ],
  },
  rooms: {
    label: "Odalar",
    icon: "BedDouble",
    desc: "Oda kartları: ekle, düzenle, sil",
    fields: [
      {
        key: "", label: "Odalar", type: "array", itemTitle: "name", root: true,
        template: { slug: "yeni-oda", name: "Yeni Oda", capacity: "1 Kişi", size: "", desc: "", features: [], image: "" },
        itemFields: [
          { key: "image", label: "Oda Fotoğrafı", type: "image" },
          { key: "name", label: "Oda Adı" },
          { key: "capacity", label: "Kapasite (örn. 2 Kişi)" },
          { key: "size", label: "Rozet (örn. Deniz Manzaralı)" },
          { key: "desc", label: "Açıklama", type: "area" },
          { key: "features", label: "Özellikler (her satır bir özellik)", type: "lines" },
          { key: "slug", label: "URL Anahtarı (benzersiz, boşluksuz)" },
        ],
      },
    ],
  },
  services: {
    label: "Hizmetler",
    icon: "ConciergeBell",
    desc: "Hizmet kartları ve ikonları",
    fields: [
      {
        key: "", label: "Hizmetler", type: "array", itemTitle: "title", root: true,
        template: { icon: "Sparkles", title: "Yeni Hizmet", desc: "" },
        itemFields: [
          { key: "icon", label: "İkon", type: "icon" },
          { key: "title", label: "Başlık" },
          { key: "desc", label: "Açıklama", type: "area" },
        ],
      },
    ],
  },
  values: {
    label: "Değerler",
    icon: "HeartHandshake",
    desc: "Hakkımızda sayfasındaki değer kartları",
    fields: [
      {
        key: "", label: "Değerler", type: "array", itemTitle: "title", root: true,
        template: { icon: "HeartHandshake", title: "Yeni Değer", desc: "" },
        itemFields: [
          { key: "icon", label: "İkon", type: "icon" },
          { key: "title", label: "Başlık" },
          { key: "desc", label: "Açıklama", type: "area" },
        ],
      },
    ],
  },
  about: {
    label: "Hakkımızda İçeriği",
    icon: "BookOpen",
    desc: "Hikaye, görseller ve yaşam kültürü bölümleri",
    fields: [
      {
        key: "story", label: "Hikaye Bölümü", type: "group",
        fields: [
          { key: "overline", label: "Üst Etiket" },
          { key: "title", label: "Başlık" },
          { key: "description", label: "Açıklama", type: "area" },
          { key: "paragraph", label: "Ek Paragraf", type: "area" },
          { key: "quote", label: "Alıntı (tırnak içi cümle)" },
        ],
      },
      {
        key: "images", label: "Görseller", type: "group",
        fields: [
          { key: "main", label: "Ana Görsel", type: "image" },
          { key: "students", label: "İkinci Görsel", type: "image" },
        ],
      },
      {
        key: "lifestyle", label: "Yaşam Kültürü Bölümü", type: "group",
        fields: [
          { key: "overline", label: "Üst Etiket" },
          { key: "title", label: "Başlık" },
          { key: "description", label: "Açıklama", type: "area" },
          { key: "bullets", label: "Madde Listesi (her satır bir madde)", type: "lines" },
          { key: "image", label: "Görsel", type: "image" },
        ],
      },
    ],
  },
  included: {
    label: "Ücrete Dahil",
    icon: "ListChecks",
    desc: "Odalar sayfasındaki 'ücrete dahil' bandı",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık" },
      { key: "description", label: "Açıklama", type: "area" },
      { key: "items", label: "Maddeler (her satır bir madde)", type: "lines" },
    ],
  },
  servicesBanner: {
    label: "Hizmetler Bannerı",
    icon: "Image",
    desc: "Hizmetler sayfasındaki büyük görsel bant",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık" },
      { key: "text", label: "Metin", type: "area" },
      { key: "ctaLabel", label: "Buton Metni" },
      { key: "image", label: "Arka Plan Görseli", type: "image" },
    ],
  },
  gallery: {
    label: "Galeri",
    icon: "Images",
    desc: "Galeri fotoğrafları: yükle, ekle, düzenle, sil",
    fields: [
      {
        key: "", label: "Fotoğraflar", type: "array", itemTitle: "alt", root: true,
        template: { src: "", alt: "Yeni fotoğraf", ratio: "aspect-[4/3]" },
        itemFields: [
          { key: "src", label: "Fotoğraf", type: "image" },
          { key: "alt", label: "Açıklama (alt)" },
          {
            key: "ratio", label: "Kart Oranı", type: "select",
            options: [
              { value: "aspect-[3/4]", label: "Dikey (3:4)" },
              { value: "aspect-[4/5]", label: "Dikey Geniş (4:5)" },
              { value: "aspect-[4/3]", label: "Yatay (4:3)" },
              { value: "aspect-square", label: "Kare (1:1)" },
            ],
          },
        ],
      },
    ],
  },
  videos: {
    label: "Videolar",
    icon: "Clapperboard",
    desc: "Video kartları: ilk video ana sayfada öne çıkar",
    fields: [
      {
        key: "", label: "Videolar", type: "array", itemTitle: "title", root: true,
        template: { id: "yeni-video", title: "Yeni Video", subtitle: "", duration: "", poster: "", reel: "", src: "" },
        itemFields: [
          { key: "reel", label: "Instagram Reel Bağlantısı", type: "reel" },
          { key: "title", label: "Başlık" },
          { key: "subtitle", label: "Alt Başlık" },
          { key: "duration", label: "Etiket (örn. Reel, Tanıtım)" },
          { key: "poster", label: "Kapak Görseli (otomatik gelir, isterseniz değiştirin)", type: "image" },
          { key: "src", label: "Video Dosyası (Reel yoksa)", type: "video" },
          { key: "id", label: "Anahtar (benzersiz, boşluksuz)" },
        ],
      },
    ],
  },
  cta: {
    label: "CTA Bandı",
    icon: "Megaphone",
    desc: "Sayfaların altındaki koyu çağrı alanı",
    fields: [
      { key: "overline", label: "Üst Etiket" },
      { key: "title", label: "Başlık" },
      { key: "text", label: "Metin", type: "area" },
      { key: "primaryLabel", label: "Birinci Buton Metni" },
      { key: "secondaryLabel", label: "İkinci Buton Metni" },
    ],
  },
  footer: {
    label: "Alt Kısım (Footer)",
    icon: "PanelBottom",
    desc: "Sayfa altı metinleri",
    fields: [
      { key: "description", label: "Kısa Tanıtım", type: "area" },
      { key: "note", label: "Not Kutusu", type: "area" },
      { key: "bottomTagline", label: "Alt Slogan" },
    ],
  },
};
